import Hero from "../components/Hero";
import FeaturedProjects from "../components/FeaturedProjects";
import Testimonials from "../components/Testimonials";
import Experience from "../components/Experience";
import Expertise from "../components/Expertise";
import Contact from "../components/Contact";

const Home = () => {
  return (
    <>
      <Hero />
      <FeaturedProjects />
      <Testimonials />
      <Experience />
      <Expertise />
      <Contact />
    </>
  );
};

export default Home;
